import { Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  updateFormData,
  addActivity,
  removeActivity,
  updateActivity,
  resetFormData,
} from "../redux/eventOrganiserSlice";
import userStore from "../../../zustand/userStore";
import ActivityInput from "./ActivityInput";
import { submitEvent } from "../redux/eventOrganiserThunks";
import { updateEventRequestThunk } from "../../AcademicCalendar/redux/createEventRequestThunk";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import moment from "moment";
import { GetUserAccessThunk } from "../../../pages/user/redux/userThunk";
import "./events-responsive.css";

export default function AddEvent() {
  const location = useLocation();
  const prefilledEvent = location.state?.event;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = userStore((state) => state.user);

  const { formData, status, error } = useSelector(
    (state) => state.eventOrganiser
  );
  const { userAccessData, userCountRestrictions } = useSelector(
    (state) => state.user
  );

  // const planType = userData.payments?.at(0).plan_type || "";
  const planType = userData?.payments?.[0]?.plan_type || "";

  useEffect(() => {
    if (userData?.id) {
      dispatch(GetUserAccessThunk());
    }
  }, [dispatch, userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(updateFormData({ [name]: value }));
  };

  const handleAddActivity = () => {
    dispatch(addActivity());
  };

  const handleRemoveActivity = (index) => {
    dispatch(removeActivity(index));
  };

  const handleActivityChange = (index, field, value) => {
    dispatch(updateActivity({ index, field, value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.activities.length === 0) {
      return alert("Please enter at least one activity to proceed");
    }

    if (
      formData.endTime &&
      formData.startTime &&
      moment(formData.endTime, "YYYY-MM-DDTHH:mm").isSameOrBefore(
        moment(formData.startTime, "YYYY-MM-DDTHH:mm")
      )
      // moment(formData.endTime, "HH:mm").isSameOrBefore(
      //   moment(formData.startTime, "HH:mm")
      // )
    ) {
      return alert(
        "End date & time should be greater than Start date & time. Please select a valid End date & time."
      );
    }

    if (
      userData.roles === "trial" &&
      userAccessData?.total_events >= userCountRestrictions?.demo?.events
    ) {
      return alert(
        `You are in a trial period and can create only ${userCountRestrictions.demo.events} events.`
      );
    }

    if (
      planType === "customized" &&
      userAccessData?.total_events >= userCountRestrictions?.individual?.events
    ) {
      return alert(
        `You are in Inidividual Plan and can create only ${userCountRestrictions.individual.events} events.`
      );
    }

    const payloadForUpdateRequest = {
      event_name: formData.eventName,
      event_date: formData.date,
      start_time: formData.startTime,
      end_time: formData.endTime,
      activities: formData.activities.map((act) => ({
        activity_name: act.activityName || act.name || "",
        description: act.description || "",
      })),
      status: prefilledEvent ? 1 : 0,
    };
    const activitiesForSubmitEvent = formData.activities.map((act) => ({
      name: act.activityName || act.name || "",
      description: act.description || "",
      activity_head_id:
        act.activity_head_id !== undefined ? act.activity_head_id : null,
      assigned_users:
        act.assigned_users !== undefined ? act.assigned_users : [],
      cost_sheets: act.cost_sheets !== undefined ? act.cost_sheets : [],
    }));
    const formDataForSubmitEvent = {
      ...formData,
      activities: activitiesForSubmitEvent,
    };
    try {
      if (prefilledEvent?.id) {
        // 1. Update the original event
        await dispatch(
          updateEventRequestThunk({
            id: prefilledEvent.id,
            data: payloadForUpdateRequest,
          })
        ).unwrap();
        // 2. Submit the event
        await dispatch(
          submitEvent({ formData: formDataForSubmitEvent, userData })
        ).unwrap();
        alert("Event approved successfully!");
        navigate("/requestEvent");
      } else {
        // Submit new event
        await dispatch(
          submitEvent({ formData: formDataForSubmitEvent, userData })
        ).unwrap();
        navigate("/showEvents");
      }

      dispatch(resetFormData());
    } catch (error) {
      console.error("Submit failed:", error);
      alert("Failed: " + error?.message || error);
    }
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) {
      return "";
    }
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        console.warn(
          "Invalid date string received by formatDateForInput:",
          dateString
        );
        return "";
      }
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    } catch (error) {
      console.error(
        "Error parsing date in formatDateForInput:",
        dateString,
        error
      );
      return "";
    }
  };
  useEffect(() => {
    if (prefilledEvent) {
      console.log(
        "prefilledEvent.event_date received:",
        prefilledEvent.event_date
      );
      const formattedDate = formatDateForInput(prefilledEvent.event_date);
      console.log("Formatted date for input:", formattedDate);

      dispatch(
        updateFormData({
          eventName: prefilledEvent.event_name || "",
          date: formatDateForInput(prefilledEvent.event_date),
          startTime: prefilledEvent.start_time || "",
          endTime: prefilledEvent.end_time || "",
          activities: (prefilledEvent.activities || []).map((a) => ({
            activityName: a.activity_name || a.name || "",
            description: a.activity_desc || a.description || "",
          })),
        })
      );
    } else {
      dispatch(resetFormData());
    }
  }, [prefilledEvent, dispatch]);
  const containerStyle = {
    maxWidth: "900px",
    margin: "15px auto",
    padding: "20px 30px",
    background: "linear-gradient(135deg, #7B2FF7 0%, #9B5DE5 50%, #B185DB 100%)",
    boxShadow: "0 8px 32px rgba(123, 47, 247, 0.3)",
    borderRadius: "16px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  };
  return (
    <Suspense fallback={<>Loading...</>}>
      <div className="main_container add-event-container" style={containerStyle}>
        {/* <Sidebar />
        <Navbar /> */}
        <div className="right_col" role="main">
          {/* Page Title */}
          <h2 style={{
            color: "#fff",
            textAlign: "center",
            marginBottom: "20px",
            fontSize: "1.5rem",
            fontWeight: "600",
            textShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}>
            {prefilledEvent ? "Approve Event" : "Create New Event"}
          </h2>

          <div
            className="add-event-form-card"
            style={{
              background: "#fff",
              padding: "32px",
              maxWidth: 1000,
              margin: "0 auto",
              borderRadius: "16px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.12)",
            }}
          >
            <form onSubmit={handleSubmit}>
              {/* Event Name */}
              <div style={{ marginBottom: 24 }}>
                <label
                  className="add-event-label"
                  style={{
                    fontWeight: "600",
                    display: "block",
                    marginBottom: 8,
                    color: "#333",
                    fontSize: "0.95rem",
                  }}
                >
                  Event Name
                </label>
                <input
                  type="text"
                  name="eventName"
                  className="add-event-input"
                  value={formData.eventName}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter event name"
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    border: "2px solid #e0e0e0",
                    fontSize: "0.95rem",
                    transition: "border-color 0.3s, box-shadow 0.3s",
                    outline: "none",
                  }}
                />
              </div>
              {false && (
                <div style={{ flex: 1 }}>
                  <label
                    className="add-event-label"
                    style={{
                      fontWeight: "600",
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                    }}
                  >
                    Date
                  </label>
                  <input
                    type="date"
                    name="date"
                    className="add-event-input"
                    value={formData.date}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                    }}
                  />
                </div>
              )}

              {/* Date & Time Row */}
              <div className="add-event-datetime-row" style={{ display: "flex", gap: 20, marginBottom: 24 }}>
                <div style={{ flex: 1 }}>
                  <label
                    className="add-event-label"
                    style={{
                      fontWeight: "600",
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                      fontSize: "0.95rem",
                    }}
                  >
                    Start Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    name="startTime"
                    className="add-event-input"
                    value={formData.startTime}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                      fontSize: "0.95rem",
                      transition: "border-color 0.3s, box-shadow 0.3s",
                      outline: "none",
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label
                    className="add-event-label"
                    style={{
                      fontWeight: "600",
                      display: "block",
                      marginBottom: 8,
                      color: "#333",
                      fontSize: "0.95rem",
                    }}
                  >
                    End Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    name="endTime"
                    className="add-event-input"
                    value={formData.endTime}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: "100%",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      border: "2px solid #e0e0e0",
                      fontSize: "0.95rem",
                      transition: "border-color 0.3s, box-shadow 0.3s",
                      outline: "none",
                    }}
                  />
                </div>
              </div>

              {/* Activities Section */}
              {formData.activities.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                  <h3 style={{
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    color: "#7B2FF7",
                    marginBottom: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span style={{
                      width: "24px",
                      height: "24px",
                      background: "#7B2FF7",
                      color: "#fff",
                      borderRadius: "50%",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.75rem"
                    }}>
                      {formData.activities.length}
                    </span>
                    Activities
                  </h3>
                </div>
              )}

              {formData.activities.map((activity, index) => (
                <ActivityInput
                  key={index}
                  index={index}
                  activity={activity}
                  onChange={handleActivityChange}
                  onRemove={() => handleRemoveActivity(index)}
                />
              ))}

              {/* Add Activity Button */}
              <div style={{ marginBottom: 28, textAlign: "right" }}>
                <button
                  type="button"
                  className="add-event-add-activity-btn"
                  onClick={handleAddActivity}
                  style={{
                    padding: "10px 20px",
                    background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "0.9rem",
                    fontWeight: "600",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(40, 167, 69, 0.3)",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                >
                  + Add Activity
                </button>
              </div>

              {/* Action Buttons */}
              <div className="add-event-buttons" style={{
                textAlign: "center",
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
                gap: "16px",
                paddingTop: "20px",
                borderTop: "1px solid #eee"
              }}>
                <button
                  type="submit"
                  className="add-event-submit-btn"
                  disabled={status === "loading"}
                  style={{
                    padding: "12px 32px",
                    background: prefilledEvent
                      ? "linear-gradient(135deg, #28a745 0%, #20c997 100%)"
                      : "linear-gradient(135deg, #007BFF 0%, #0056b3 100%)",
                    color: "white",
                    border: "none",
                    borderRadius: "10px",
                    fontWeight: "600",
                    cursor: status === "loading" ? "not-allowed" : "pointer",
                    fontSize: "0.95rem",
                    boxShadow: prefilledEvent
                      ? "0 4px 15px rgba(40, 167, 69, 0.4)"
                      : "0 4px 15px rgba(0, 123, 255, 0.4)",
                    transition: "transform 0.2s, box-shadow 0.2s",
                    opacity: status === "loading" ? 0.7 : 1,
                  }}
                >
                  {status === "loading"
                    ? "Submitting..."
                    : prefilledEvent
                    ? "Approve Event"
                    : "Submit"}
                </button>
                <button
                  type="button"
                  className="add-event-cancel-btn"
                  onClick={() => navigate("/showEvents")}
                  style={{
                    padding: "12px 32px",
                    background: "#f8f9fa",
                    color: "#6c757d",
                    border: "2px solid #dee2e6",
                    borderRadius: "10px",
                    fontWeight: "600",
                    cursor: "pointer",
                    fontSize: "0.95rem",
                    transition: "background 0.2s, border-color 0.2s",
                  }}
                >
                  Cancel
                </button>
              </div>
              {status === "failed" && (
                <p style={{
                  color: "#dc3545",
                  textAlign: "center",
                  marginTop: "16px",
                  padding: "12px",
                  background: "#fff5f5",
                  borderRadius: "8px",
                  fontSize: "0.9rem"
                }}>
                  Error: {error}
                </p>
              )}
            </form>
          </div>
        </div>
        {/* <Footer /> */}
      </div>
    </Suspense>
  );
}
